










































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import pagerequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import moment from "moment";
import AppConsts from "@/lib/appconst";

class PageReportWarrantyActivationRequest extends pagerequest {
  keyword: string;
  brandId: number;
  categoryId: number;
  fromDate: Date;
  toDate: Date;
  clientCode: string;
}

@Component
export default class WarrantyActivation extends mixins(ListMixin, AbpBase) {
  namespace = "reportWarrantyActivation";
  pagerequest: PageReportWarrantyActivationRequest =
    new PageReportWarrantyActivationRequest();
  creationTime: Date[] = [];
  categories = [];
  brands = [];
  clients = [];
  spinShow: boolean = false;

  isClient() {
    return !_.isNil(this.$store.state.session.client);
  }

  async changeClientCode() {
    await this.getCategories();
  }

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.$store.state.client.clientsForSelect;
        if (!this.isClient()) {
          this.pagerequest.clientCode = re.length === 0 ? "" : re[0].code;
        }
        this.clients = re;
      });
  }

  get store() {
    return this.$store.state.reportWarrantyActivation;
  }
  getBrands() {
    this.$store
      .dispatch({
        type: "masterData/getBrands",
      })
      .then((result) => {
        result.unshift({
          id: 0,
          code: AppConsts.allItemValue,
          name: this.L(AppConsts.All),
        });
        this.pagerequest.brandId = result.length === 0 ? "" : result[0].id;
        this.brands = result;
      });
  }
  getCategories() {
    this.$store
      .dispatch({
        type: "category/getCategoriesByClientForSelect",
        data: {
          hasAllItem: true,
          clientCode: this.pagerequest.clientCode
        },
      })
      .then(() => {
        var re = this.$store.state.category.categoriesOfClientForSelect;
        if (re.length > 0) {
          this.pagerequest.categoryId = re[0].id;
        }
        this.categories = re;
      });
  }
  get list() {
    var re = this.store.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function (item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    this.pagerequest.fromDate = null;
    this.pagerequest.toDate = null;

    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.fromDate = moment(this.creationTime[0])
        .startOf("d")
        .toDate();
    }
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.toDate = moment(this.creationTime[1])
        .endOf("d")
        .toDate();
    }
  }
  async exportToExcel() {
    this.preGetPage();
    await this.$store.dispatch({
      type: `${this.namespace}/export`,
      data: this.pagerequest,
    });
  }
  reset() {
    this.pagerequest = new PageReportWarrantyActivationRequest();
    var defaultDate = new Date();
    var defaultDateFrom = moment().add(-7, "d").toDate();
    this.creationTime = [defaultDateFrom, defaultDate];
  }

  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 50,
      fixed: "left",
    },
    {
      title: Util.L("HiddenCode"),
      width: 150,
      key: "hiddenCode",
      fixed: "left",
    },
    {
      title: Util.L("MainSerialNo"),
      width: 150,
      key: "mainSerialNo",
    },
    {
      title: Util.L("SubSerialNo"),
      width: 150,
      key: "subSerialNo",
    },
    {
      title: Util.L("SKU"),
      width: 150,
      key: "product.sku",
      fixed: "left",
      render: (h: any, params: any) => {
        if (_.isNil(params.row.product)) return "";
        return h("span", params.row.product.sku);
      },
    },
    {
      title: Util.L("ProductName"),
      width: 200,
      key: "product.name",
      fixed: "left",
      render: (h: any, params: any) => {
        if (_.isNil(params.row.product)) return "";
        return h("span", params.row.product.name);
      },
    },
    {
      title: Util.L("Client"),
      width: 150,
      key: "product.clientName",
      render: (h: any, params: any) => {
        if (_.isNil(params.row.product)) return "";
        return h("span", params.row.product.clientName);
      },
    },
    {
      title: Util.L("BrandName"),
      width: 150,
      key: "product.brandName",
      render: (h: any, params: any) => {
        if (_.isNil(params.row.product)) return "";
        return h("span", params.row.product.brandName);
      },
    },
    {
      title: Util.L("Category"),
      width: 150,
      key: "product.categoryName",
      render: (h: any, params: any) => {
        if (_.isNil(params.row.product)) return "";
        return h("span", params.row.product.categoryName);
      },
    },
    {
      title: Util.L("Distributor"),
      width: 150,
      key: "distributor.id",
      render: (h: any, params: any) => {
        if (_.isNil(params.row.distributor)) return "";
        return h("span", params.row.distributor.name);
      },
    },
    {
      title: Util.L("ĐL phân phối"),
      width: 150,
      key: "salesmanName",
    },
    {
      title: Util.L("ActivatorName"),
      width: 150,
      key: "activatorName",
    },
    {
      title: Util.L("ConsumerName"),
      width: 150,
      key: "consumerName",
    },
    {
      title: Util.L("ConsumerPhone"),
      width: 150,
      key: "consumerPhone",
    },
    {
      title: Util.L("ConsumerFullAddress"),
      width: 150,
      key: "consumerFullAddress",
    },
    {
      title: Util.L("ConsumerIdentityCard"),
      width: 150,
      key: "consumerIdentityCard",
    },
    {
      title: Util.L("ConsumerProvinceId"),
      width: 150,
      key: "consumerProvinceName",
    },
    {
      title: Util.L("WarrantyActivateDate"),
      key: "warrantyActivateDate",
      width: 150,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.warrantyActivateDate)) return "";
        return h(
          "span",
          Util.toViewDatePickerString(params.row.warrantyActivateDate)
        );
      },
    },
    {
      title: Util.L("StampActivateDate"),
      key: "stampActivateDate",
      width: 150,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.stampActivateDate)) return "";
        return h(
          "span",
          Util.toViewDatePickerString(params.row.stampActivateDate)
        );
      },
    },
    {
      title: Util.L("OutboundDate"),
      key: "outboundDate",
      width: 150,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.outboundDate)) return "";
        return h("span", Util.toViewDatePickerString(params.row.outboundDate));
      },
    },
    {
      title: Util.L("WarrantyDate"),
      key: "warrantyDate",
      width: 150,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.warrantyDate)) return "";
        return h("span", Util.toViewDatePickerString(params.row.warrantyDate));
      },
    },
    {
      title: Util.L("ManufactureMonth"),
      key: "manufactureMonth",
      width: 150,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.manufactureMonth)) return "";
        return h("span", Util.toMonthYearString(params.row.manufactureMonth));
      },
    },
  ];
  async created() {
    this.spinShow = true;
    try {
      this.reset();
      await this.getClients();
      this.getCategories();
      this.getBrands();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
